"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
exports.UseContainerDimensions = function (myRef) {
    var _a = react_1.useState({ width: 0, height: 0 }), dimensions = _a[0], setDimensions = _a[1];
    react_1.useEffect(function () {
        var getDimensions = function () { return ({
            width: (myRef && myRef.current.offsetWidth) || 0,
            height: (myRef && myRef.current.offsetHeight) || 0
        }); };
        var handleResize = function () {
            setDimensions(getDimensions());
        };
        if (myRef.current) {
            setDimensions(getDimensions());
        }
        window.addEventListener('resize', debounce_1.default(function () { return handleResize; }, 2000));
        return function () {
            return window.removeEventListener('resize', debounce_1.default(function () { return handleResize; }, 2000));
        };
    }, [myRef]);
    return dimensions;
};
//# sourceMappingURL=UseContainerDimensions.js.map